import { EntityApps } from './entity-apps.model';

/** What showDashboard needs out of the apps response. A type alias, so it erases at runtime. */
export type DashboardApps = Pick<EntityApps, 'appsIds' | 'standaloneAppsIds'>;

export class Groups {
    [key: string | number]: any;

    // WARNING: analytics-packages.component.ts iterates Object.keys() over an
    // instance of this class and calls .map() on every value, so any own
    // enumerable property that is not a number[] breaks that page — and the index
    // signature above means TypeScript will not catch it. Class methods live on
    // the prototype, so Object.keys() skips them and they are safe: do NOT turn
    // them into arrow-function properties.
    mimesys: number[] = [1, 2, 3, 4, 9, 10, 11, 12, 13, 14, 15, 16];
    fit: number[] = [5, 6, 7, 8];
    noDevice: number[] = [17];

    // Takes app ids, not packageType ids: app 5 = FIT, app 7 = 360Depict
    // (see APP in the backend constants.js). Do not match against the arrays above.
    //
    // The depict half asks for the STANDALONE product on purpose: a Fit Depict entity
    // carries app 7 as well, but reaches it bundled with Fit, and that does not grant a
    // dashboard of its own.
    // Both lists are defaulted: an API older than this front sends no standaloneAppsIds,
    // and the sidebar getter runs on every change detection cycle, so a missing field
    // crashes the whole app render instead of just hiding a card.
    showDashboard(apps?: DashboardApps | null): boolean {
        const appsIds = apps?.appsIds ?? [];
        const depict360 = (apps?.standaloneAppsIds ?? []).includes(7);
        const fit = appsIds.includes(5);
        const mimesys = appsIds.some(id => this.mimesys.includes(id));
        return depict360 || (mimesys && fit);
    }
}
